import { render } from "./userNew.vue?vue&type=template&id=098bae40&scoped=true"
import script from "./userNew.vue?vue&type=script&lang=js"
export * from "./userNew.vue?vue&type=script&lang=js"

import "./userNew.vue?vue&type=style&index=0&id=098bae40&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098bae40"]])

export default __exports__